<dashboardnav>

  <cradua-lga
  [states]="states$ | async"
  [lgas]="lgas$ | async"

  (changeEmit)="onSubmitLga($event)"
  (deleteEvent)="onDeleteLga($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-lga>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
